import React from 'react';
import {useState,useEffect,Component} from 'react';
import { useNavigate } from 'react-router-dom';
import { BrowserRouter as Router,Routes,Route,Link} from 'react-router-dom';

import '../Resources/dashboard.css';
import axios from '../../axios.js';
import moment from 'moment/moment';
import Sidebar from './sidebar.js';
import Navbar from './navbar.js';

function Newcrm_createreceipt(){



  
   //Checking Sessions
 // Access value associated with the login status
 const logstatus=sessionStorage.getItem("logStatus00");
 const logtype=sessionStorage.getItem("logType00");
 const logid=sessionStorage.getItem("logId00");
 const token=sessionStorage.getItem("logToken00");
 const editId=sessionStorage.getItem("EditId00");
 const counterid=sessionStorage.getItem("CounterId00");


 //Checking if Sessions are Set

// alert(logstatus,loguser,logadminid);
 //Sessions Not Set
 {/* if(((logstatus==null)||(logstatus==""))||((logid==null)||(logid==""))||((token==null)||(token==" "))||((busyid==null)||(busyid==" "))||((counterid==null)||(counterid==" "))){
  
   sessionStorage.removeItem("logStatus00");
   sessionStorage.removeItem("logId00");
   sessionStorage.removeItem("logToken00");
   sessionStorage.removeItem("BusyId00");
   sessionStorage.removeItem("BusyName00");
   sessionStorage.removeItem("CounterId00");
   
 
    window.location.replace("/businesstools-login");
   }
  
   //Sessions Set
   else{

   */}

    
      
//Variables
const[Tbanks,setTbanks] = useState([]);//SetData Variable
const[customers,setcustomers] = useState([],);//SetData Variable
const[cdefault,setcdefault] = useState(0);

//Error Variable
const[errorvar,seterrorvar] = useState();

//customers_count
const[customers_count,setcustomers_count] = useState(1);
//csuccess
//const[ccsuccess,setccsuccess] = useState(0);
//date



//receipt_number
const[receipt_number,setreceipt_number]=useState();const updatereceipt_number = (event) => { setreceipt_number(event.target.value);}; const[receipt_number_er,setreceipt_number_er]=useState();
//receipt_date
const[receipt_date,setreceipt_date]=useState();const updatereceipt_date = (event) => { setreceipt_date(event.target.value);}; const[receipt_date_er,setreceipt_date_er]=useState();
//receipt_head
const[receipt_head,setreceipt_head]=useState();const updatereceipt_head = (event) => { setreceipt_head(event.target.value);}; const[receipt_head_er,setreceipt_head_er]=useState();
//type
const[type,settype]=useState();const updatetype = (event) => { settype(event.target.value);}; const[type_er,settype_er]=useState();
//customer_name
const[customer_name,setcustomer_name]=useState();const updatecustomer_name = (event) => { setcustomer_name(event.target.value);}; const[customer_name_er,setcustomer_name_er]=useState();
//email
const[email,setemail]=useState();const updateemail = (event) => { setemail(event.target.value);}; const[email_er,setemail_er]=useState();
//contact
const[contact,setcontact]=useState();const updatecontact = (event) => { setcontact(event.target.value);}; const[contact_er,setcontact_er]=useState();
//amount
const[amount,setamount]=useState();const updateamount = (event) => { setamount(event.target.value); calculator(); }; const[amount_er,setamount_er]=useState();
//discount_per
const[discount_per,setdiscount_per]=useState();const updatediscount_per = (event) => { setdiscount_per(event.target.value); calculator(); }; const[discount_per_er,setdiscount_per_er]=useState();
//discount_amt
const[discount_amt,setdiscount_amt]=useState();const updatediscount_amt = (event) => { setdiscount_amt(event.target.value); calculator(); }; const[discount_amt_er,setdiscount_amt_er]=useState();
//sgst_per
const[sgst_per,setsgst_per]=useState();const updatesgst_per = (event) => { setsgst_per(event.target.value); calculator(); }; const[sgst_per_er,setsgst_per_er]=useState();
//sgst_amt
const[sgst_amt,setsgst_amt]=useState();const updatesgst_amt = (event) => { setsgst_amt(event.target.value); calculator(); }; const[sgst_amt_er,setsgst_amt_er]=useState();
//cgst_per
const[cgst_per,setcgst_per]=useState();const updatecgst_per = (event) => { setcgst_per(event.target.value); calculator(); }; const[cgst_per_er,setcgst_per_er]=useState();
//cgst_amt
const[cgst_amt,setcgst_amt]=useState();const updatecgst_amt = (event) => { setcgst_amt(event.target.value); calculator(); }; const[cgst_amt_er,setcgst_amt_er]=useState();
//igst_per
const[igst_per,setigst_per]=useState();const updateigst_per = (event) => { setigst_per(event.target.value); calculator(); }; const[igst_per_er,setigst_per_er]=useState();
//igst_amt
const[igst_amt,setigst_amt]=useState();const updateigst_amt = (event) => { setigst_amt(event.target.value); calculator(); }; const[igst_amt_er,setigst_amt_er]=useState();
//payable_amount
const[payable_amount,setpayable_amount]=useState();const updatepayable_amount = (event) => { setpayable_amount(event.target.value); calculator(); }; const[payable_amount_er,setpayable_amount_er]=useState();
//amount_paid
const[amount_paid,setamount_paid]=useState();const updateamount_paid = (event) => { setamount_paid(event.target.value);}; const[amount_paid_er,setamount_paid_er]=useState();
//payment_status
const[payment_status,setpayment_status]=useState();const updatepayment_status = (event) => { setpayment_status(event.target.value);}; const[payment_status_er,setpayment_status_er]=useState();
//payment_mode
const[payment_mode,setpayment_mode]=useState();const updatepayment_mode = (event) => { setpayment_mode(event.target.value);}; const[payment_mode_er,setpayment_mode_er]=useState();
//transaction_id
const[transaction_id,settransaction_id]=useState();const updatetransaction_id = (event) => { settransaction_id(event.target.value);}; const[transaction_id_er,settransaction_id_er]=useState();
//receipt_remarks
const[receipt_remarks,setreceipt_remarks]=useState();const updatereceipt_remarks = (event) => { setreceipt_remarks(event.target.value);}; const[receipt_remarks_er,setreceipt_remarks_er]=useState();
//total
const[total,settotal]=useState();const updatetotal = (event) => { settotal(event.target.value); calculator(); }; const[total_er,settotal_er]=useState();

//ERROR VARIABLES 
const[error_msg,seterror_msg]=useState();

  
    

//******************* CREATE NEW RECEIPT FUNCTION START ********************//
function createnewreceipt(){

  //Setting Error Variables
setreceipt_number_er(" ");setreceipt_date_er(" ");setreceipt_head_er(" ");settype_er(" ");setcustomer_name_er(" ");setemail_er(" ");setcontact_er(" ");setamount_er(" ");setdiscount_per_er(" ");setdiscount_amt_er(" ");
setsgst_per_er(" ");setsgst_amt_er(" ");setcgst_per_er(" ");setcgst_amt_er(" ");setigst_per_er(" ");setigst_amt_er(" ");settotal_er(" ");setpayable_amount_er(" ");
setamount_paid_er(" "); setpayment_status_er(" ");setpayment_mode_er(" ");setreceipt_remarks_er(" ");settransaction_id_er(" ");


//Checking if user loggedin
if(((logstatus!=null)||(logstatus!=""))&&((logid!=null)||(logid!=""))&&((token!=null)||(token!=" "))/*&&((busyid!=null)||(busyid!=" "))&&((counterid!=null)||(counterid!=" "))*/){
 
 
  axios.post("newcrm-create-receipt", {
   Log_id:logid,
   Token:token,
   Receipt_number:receipt_number,
   Receipt_date:receipt_date,
   Receipt_head:receipt_head,
   Type:type,
   Customer_name:customer_name,
   Email:email,
   Contact:contact,
   Amount:amount,
   Discount_per:discount_per,
   Discount_amt:discount_amt,
   Total:total,
   Sgst_per: sgst_per,
   Sgst_amt: sgst_amt,
   Cgst_per: cgst_per,
   Cgst_amt: cgst_amt,
   Igst_per: igst_per,
   Igst_amt: igst_amt,
   Payable_amount: payable_amount,
   Amount_paid: amount_paid,
   Payment_status: payment_status,
   Payment_mode: payment_mode,
   Transaction_id: transaction_id,
   Receipt_remarks: receipt_remarks,
   Total: total,

 })
 .then((response) => {


  //Invalid Entries
 
  if(response.data.error==103){     seterror_msg(response.data.error_msg);  return; }

  if(response.data.error==111){     seterror_msg(response.data.error_msg); return; }
  
  //Invalid Session
  if((response.data.error)==100){ 
      //Remove Session Variables and redirect to login
     sessionStorage.removeItem("logStatus00");
     sessionStorage.removeItem("logId00");
     sessionStorage.removeItem("logToken00");

     window.location.replace("/");

  }

   //Validation Errors
 if(response.data.validatorerror){
  setreceipt_number_er(response.data.validatorerror.Receipt_number);
  setreceipt_date_er(response.data.validatorerror.Receipt_date);
  setreceipt_head_er(response.data.validatorerror.Receipt_head);
  settype_er(response.data.validatorerror.Type);
  setcustomer_name_er(response.data.validatorerror.Customer_name);
  setcontact_er(response.data.validatorerror.Contact);
  setemail_er(response.data.validatorerror.Email);
  setamount_er(response.data.validatorerror.Amount);
  setdiscount_per_er(response.data.validatorerror.Discount_per);
  setdiscount_amt_er(response.data.validatorerror.Discount_amt);
  setsgst_per_er(response.data.validatorerror.Sgst_per);
  setsgst_amt_er(response.data.validatorerror.Sgst_amt);
  setcgst_per_er(response.data.validatorerror.Cgst_per);
  setcgst_amt_er(response.data.validatorerror.Cgst_amt);
  setigst_per_er(response.data.validatorerror.Igst_per);
  setigst_amt_er(response.data.validatorerror.Igst_amt);
  setpayable_amount_er(response.data.validatorerror.Payable_amount);
  setamount_paid_er(response.data.validatorerror.Amount_paid);
  setpayment_status_er(response.data.validatorerror.Payment_status);
  setpayment_mode_er(response.data.validatorerror.Payment_mode);
  settransaction_id_er(response.data.validatorerror.Transaction_id);
  setreceipt_remarks_er(response.data.validatorerror.Receipt_remarks);
  settotal_er(response.data.validatorerror.Total);

  return;

}
//Invalid Entries
if(response.data.error==102){ 
  
  setreceipt_number_er(response.data.receipt_number_er);
  setreceipt_date_er(response.data.receipt_date_er);
  setreceipt_head_er(response.data.receipt_head_er);
  setcustomer_name_er(response.data.customer_name_er);
  setcontact_er(response.data.contact_er);
  setemail_er(response.data.email_er);
  setamount_er(response.data.amount_er);
  setdiscount_per_er(response.data.discount_per_er);
  setdiscount_amt_er(response.data.discount_amt_er);
  setsgst_per_er(response.data.sgst_per_er);
  setsgst_amt_er(response.data.sgst_amt_er);
  setcgst_per_er(response.data.cgst_per_er);
  setcgst_amt_er(response.data.cgst_amt_er);
  setigst_per_er(response.data.igst_per_er);
  setigst_amt_er(response.data.igst_amt_er);
  setpayable_amount_er(response.data.payable_amount_er);
  setamount_paid_er(response.data.amount_paid_er);
  setpayment_status_er(response.data.payment_status_er);
  setpayment_mode_er(response.data.payment_mode_er);
  settransaction_id_er(response.data.transaction_id_er);
  setreceipt_remarks_er(response.data.receipt_remarks_er);
  settotal_er(response.data.total_er);

 
  seterror_msg("Cannot Create Receipt Transaction!");  return; }

   

   //Transaction Entered Successfully
   if(response.data.successvar==1){   document.getElementById("success-card").style.display="block";  }
   //Cannot Add Transaction
   else{  seterror_msg("Cannot Create Receipt !"); }
  

});
}
 //User not Logedin
 else{
 
 //Remove Session Variables and redirect to login
   sessionStorage.removeItem("logStatus00");
   sessionStorage.removeItem("logId00");
   sessionStorage.removeItem("logToken00");


   window.location.replace("/");
 
  }
 
 }
  
 //******************* CREATE SALES FUNCTION END ********************//




 //Calculator
 function calculator(){

  let $amount = parseFloat(document.getElementById("amount").value);
  let $discount_per = parseFloat(document.getElementById("discount_per").value);
  let $discount_amount = parseFloat(document.getElementById("discount_amt").value);
  let $total = parseFloat(document.getElementById("total").value);
  let $sgst_per = parseFloat(document.getElementById("sgst_per").value);
  let $sgst_amt = parseFloat(document.getElementById("sgst_amt").value);
  let $cgst_per = parseFloat(document.getElementById("cgst_per").value);
  let $cgst_amt = parseFloat(document.getElementById("cgst_amt").value);
  let $igst_per = parseFloat(document.getElementById("igst_per").value);
  let $igst_amt = parseFloat(document.getElementById("igst_amt").value);
  let $payable_amount = parseFloat(document.getElementById("payable_amount").value);

  //Calculating Values
  if($discount_per>0){
    $discount_amount = parseFloat($amount)*parseFloat($discount_per)/100;
  }
  $total = parseFloat($amount)-parseFloat($discount_amount);
 
 if($sgst_per>0){
  $sgst_amt = parseFloat($total)*parseFloat($sgst_per)/100;
}
if($cgst_per>0){
  $cgst_amt = parseFloat($total)*parseFloat($cgst_per)/100;
}
if($igst_per>0){
  $igst_amt = parseFloat($total)*parseFloat($igst_per)/100;
}
$payable_amount = parseFloat($total+$sgst_amt+$cgst_amt+$igst_amt);

//Setting Values
setdiscount_amt($discount_amount);
setsgst_amt($sgst_amt);
setcgst_amt($cgst_amt);
setigst_amt($igst_amt);
settotal($total);
setpayable_amount($payable_amount);

}


return(
    <>


    <html lang="en">
      <head>
        {/*} Required meta tags */}
        <meta charset="utf-8" />
        <meta name="viewport" content="width=device-width, initial-scale=1, shrink-to-fit=no" />
        <title>BUSINESS SAMADHAN | CRM</title>
        {/*} plugins:css */}
        <link rel="stylesheet" href="panel/assets/vendors/mdi/css/materialdesignicons.min.css" />
        <link rel="stylesheet" href="panel/assets/vendors/flag-icon-css/css/flag-icon.min.css" />
        <link rel="stylesheet" href="panel/assets/vendors/css/vendor.bundle.base.css" />
        {/*} endinject */}
        {/*} Plugin css for this page */}
        <link rel="stylesheet" href="panel/assets/vendors/jquery-bar-rating/css-stars.css" />
        <link rel="stylesheet" href="panel/assets/vendors/font-awesome/css/font-awesome.min.css" />
        {/*} End plugin css for this page */}
        {/*} inject:css */}
        {/*} endinject */}
        {/*} Layout styles */}
        <link rel="stylesheet" href="panel/assets/css/demo_1/style.css" />
        {/*} End layout styles */}
        <link rel="shortcut icon" href="panel/assets/images/favicon.png" />
      </head>
      <body>
    
    
        <div class="container-scroller">
    
         <Sidebar />
        <div class="container-fluid page-body-wrapper">
    
    
    
    
           <Navbar />
            {/*} partial */}
            <div class="main-panel">
    
              {/* ADD CUSTOMER SUCCESS CARD START */}
              <div class="d-flex justify-content-center">
              <div class="col-md-6 grid-margin stretch-card" style={{position:"fixed",zIndex:"3",marginTop:"4rem",display:"none"}} id="success-card">
                    <div class="card">
                      <div class="card-body">
                        <h4 class="card-title  text-success">New Receipt Created Successfully !!!</h4>
                      
                        <blockquote class="blockquote">
                          <p class="mb-0"> Click the following button to close.</p>
                          <a href="newcrm-receipts"><button class="mt-3 btn btn-outline-danger">Close</button></a>
                        </blockquote>
                      </div>
                  
                    </div>
                  </div>
                  </div>
                  {/* ADD CUSTOMER SUCCESS CARD END */}
    
               
              
    
              <div class="content-wrapper pb-0">
    
              
                 {/* CREATE RECEIPT FORM START */}
                        <div class="row">
                            <div class="col-12 grid-margin">
                         


                <div class="card">
                <div class="d-flex justify-content-between">
                    <div></div>
                    <div>
                    
                   {/*}   <button type="button" class="btn btn-social-icon" onClick={()=>{ window.location.replace("newcrm-customerslist") }}>
                      <i class="mdi mdi-close-box text-danger" style={{fontSize:"2rem"}}></i>
                      </button> */}
                      </div>
                    </div>
                  <div class="card-body">
                    <h4 class="card-title">Create New Receipt</h4>
                    <div class="form-sample">
                      <p class="card-description">add information to create receipt here</p>
                      <code>{error_msg}</code>
                    
                      <div class="row">
                        <div class="col-md-6">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">Receipt Date</label>
                            <div class="col-sm-9">
                              <input type="date" class="form-control" placeholder="RCN0001" id="receipt_date" value={receipt_date} onChange={updatereceipt_date} />
                            <code>{receipt_date_er}</code>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">Receipt Number</label>
                            <div class="col-sm-9">
                              <input type="text" class="form-control" placeholder="RCN0001" id="receipt_number" value={receipt_number} onChange={updatereceipt_number} />
                            <code>{receipt_number_er}</code>
                            </div>
                          </div>
                        </div>
                        </div>
                      <div class="row">
                        <div class="col-md-6">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">Receipt Head</label>
                            <div class="col-sm-9">
                              <input type="text" class="form-control" placeholder="New ABC Receipt" id="receipt_head" value={receipt_head} onChange={updatereceipt_head} />
                            <code>{receipt_head_er}</code>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">Customer Name</label>
                            <div class="col-sm-9">
                              <input type="text" class="form-control" placeholder="Suman Soni" id="customer_name" value={customer_name} onChange={updatecustomer_name} />
                            <code>{customer_name_er}</code>
                            </div>
                          </div>
                        </div>                     
                      </div>
                        <div class="row">
                        <div class="col-md-6">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">Email</label>
                            <div class="col-sm-9">
                              <input type="text" class="form-control" placeholder="suman@gmail.com" id="email" value={email} onChange={updateemail}/>
                              <code>{email_er}</code>
                           {/*}   <button class="btn btn-light" hidden={firsts_count>0} onClick={addfirst}>Add this as new customer ....</button>
                              <p class="text-success" style={{display:"none"}} id="cst-customer"><b>New Customer Added!</b></p> */}
                            </div>
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">Contact</label>
                            <div class="col-sm-9">
                              <input type="text" class="form-control" placeholder="91989898989" id="contact" value={contact} onChange={updatecontact} />
                            <code>{contact_er}</code>
                            </div>
                          </div>
                        </div>                     
                      </div>
                      <div class="row">
                        <div class="col-md-6">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">Type</label>
                            <div class="col-sm-9">
                              <input type="text" class="form-control" placeholder="type here" id="type" value={type} onChange={updatetype} />
                            <code>{type_er}</code>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">Amount</label>
                            <div class="col-sm-9">
                              <input type="text" class="form-control" placeholder="5000.00" id="amount" value={amount} onChange={updateamount} />
                            <code>{amount_er}</code>
                            </div>
                          </div>
                        </div>                     
                      </div>
                        <div class="row">
                        <div class="col-md-6">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">Discount %</label>
                            <div class="col-sm-9">
                              <input type="text" class="form-control" placeholder="10.00" id="discount_per" value={discount_per} onChange={updatediscount_per} />
                              <code>{discount_per_er}</code>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">Discount Amount</label>
                            <div class="col-sm-9">
                              <input type="text" class="form-control" placeholder="500.00" id="discount_amt" value={discount_amt} onChange={updatediscount_amt} />
                              <code>{discount_amt_er}</code>
                            </div>
                          </div>
                        </div>                     
                      </div>
                      <div class="row">
                        <div class="col-md-6">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">Total</label>
                            <div class="col-sm-9">
                              <input type="text" class="form-control" placeholder="4500.0" id="total" value={total} onChange={updatetotal} />
                              <code>{total_er}</code>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">Transaction Id</label>
                            <div class="col-sm-9">
                              <input type="text" class="form-control" placeholder="TXN909988" id="transaction_id" value={transaction_id} onChange={updatetransaction_id} />
                              <code>{transaction_id_er}</code>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-md-6">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">Sgst %</label>
                            <div class="col-sm-9">
                              <input type="text" class="form-control" placeholder="5.00"  id="sgst_per" value={sgst_per} onChange={updatesgst_per}/>
                              <code>{sgst_per_er}</code>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">Sgst Amount</label>
                            <div class="col-sm-9">
                              <input type="text" class="form-control" placeholder="250.00" id="sgst_amt" value={sgst_amt} onChange={updatesgst_amt} />
                              <code>{sgst_amt_er}</code>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-md-6">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">Cgst %</label>
                            <div class="col-sm-9">
                              <input type="text" class="form-control" placeholder="5.00"  id="cgst_per" value={cgst_per} onChange={updatecgst_per}/>
                              <code>{cgst_per_er}</code>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">Cgst Amount</label>
                            <div class="col-sm-9">
                              <input type="text" class="form-control" placeholder="250.00" id="cgst_amt" value={cgst_amt} onChange={updatecgst_amt} />
                              <code>{cgst_amt_er}</code>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-md-6">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">Igst %</label>
                            <div class="col-sm-9">
                              <input type="text" class="form-control" placeholder="5.00"  id="igst_per" value={igst_per} onChange={updateigst_per}/>
                              <code>{igst_per_er}</code>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">Igst Amount</label>
                            <div class="col-sm-9">
                              <input type="text" class="form-control" placeholder="250.00" id="igst_amt" value={igst_amt} onChange={updateigst_amt} />
                              <code>{igst_amt_er}</code>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-md-6">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">Payable Amount</label>
                            <div class="col-sm-9">
                              <input type="text" class="form-control" placeholder="6000.00"  id="payable_amount" value={payable_amount} onChange={updatepayable_amount}/>
                              <code>{payable_amount_er}</code>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">Amount Paid</label>
                            <div class="col-sm-9">
                              <input type="text" class="form-control" placeholder="6000.00" id="amount_paid" value={amount_paid} onChange={updateamount_paid} />
                              <code>{amount_paid_er}</code>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-md-6">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">Payment Status</label>
                            <div class="col-sm-9">
                              <select class="form-control" placeholder="India"  id="payment_status" value={payment_status} onChange={updatepayment_status} style={{padding:"1rem"}}>
                              <option value=" ">select payment status</option>
                              <option value="paid">paid</option>
                              <option value="due">due</option>
                              <option value="partially paid">partially paid</option>
                              <option value="cancelled">cancelled</option>
                              </select>
                              <code>{payment_status_er}</code>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">Payment Mode</label>
                            <div class="col-sm-9">
                              <select class="form-control" pincode="420110" id="payment_mode" value={payment_mode} onChange={updatepayment_mode} style={{padding:"1rem"}}>
                              <option value=" ">select mode</option>
                              <option value="Cash">Cash</option>
                              <option value="UPI">UPI</option>
                              <option value="NEFT">NEFT</option>
                              <option value="IMPS">IMPS</option>
                              <option value="Cheque">Cheque</option>
                              <option value="Demand Draft">Demand Draft</option>
                              <option value="other">other</option>
                              </select>
                              <code>{payment_mode_er}</code>
                            </div>
                          </div>
                        </div>
                      </div>
                     
                      <div class="form-group">
                        <label for="exampleTextarea1">Receipt Remarks</label>
                        <textarea  class="form-control" rows="2" placeholder="Add your Remarks here" id="receipt_remarks" value={receipt_remarks} onChange={updatereceipt_remarks} />
                        <code>{receipt_remarks_er}</code>
                      </div>
                    
                        
                      
                        <button class="btn btn-primary" style={{fontWeight:"bold"}} onClick={createnewreceipt}>Create Receipt</button>
                      
                       
    
                     
                   
                    </div>
                  </div>
                </div>
                 {/* CREATE TEAM FORM END */}

                        
                        </div>
                    </div>
                 
                   
            
          </div>
          {/*} content-wrapper ends */}
          {/*} partial:partials/_footer.html */}
        {/*}  <footer class="footer">
            <div class="d-sm-flex justify-content-center justify-content-sm-between">
              <span class="text-muted text-center text-sm-left d-block d-sm-inline-block">Copyright © 2021 <a href="https://www.bootstrapdash.com/" target="_blank">BootstrapDash</a>. All rights reserved.</span>
              <span class="float-none float-sm-right d-block mt-1 mt-sm-0 text-center">Hand-crafted & made with <i class="mdi mdi-heart text-danger"></i></span>
            </div>
          </footer> */}
          {/*} partial */}
        </div>
        {/*} main-panel ends */}
      </div>
      {/*} page-body-wrapper ends */}
    </div>
    {/*} container-scroller */}
    {/*} plugins:js */}
    <script src="panel/assets/vendors/js/vendor.bundle.base.js"></script>
    {/*} endinject */}
    {/*} Plugin js for this page */}
    <script src="panel/assets/vendors/jquery-bar-rating/jquery.barrating.min.js"></script>
    <script src="panel/assets/vendors/chart.js/Chart.min.js"></script>
    <script src="panel/assets/vendors/flot/jquery.flot.js"></script>
    <script src="panel/assets/vendors/flot/jquery.flot.resize.js"></script>
    <script src="panel/assets/vendors/flot/jquery.flot.categories.js"></script>
    <script src="panel/assets/vendors/flot/jquery.flot.fillbetween.js"></script>
    <script src="panel/assets/vendors/flot/jquery.flot.stack.js"></script>
    <script src="panel/assets/js/jquery.cookie.js" type="text/javascript"></script>
    {/*} End plugin js for this page */}
    {/*} inject:js */}
    <script src="panel/assets/js/off-canvas.js"></script>
    <script src="panel/assets/js/hoverable-collapse.js"></script>
    <script src="panel/assets/js/misc.js"></script>
    <script src="panel/assets/js/settings.js"></script>
    <script src="panel/assets/js/todolist.js"></script>
    {/*} endinject */}
    {/*} Custom js for this page */}
    <script src="panel/assets/js/dashboard.js"></script>
    {/*} End custom js for this page */}
  </body>
</html>
    </>

);

}
//}

export default Newcrm_createreceipt;